define.alias("shared/components/shared/restricted-area/body", "preview-grid/components/shared/restricted-area/body");